import React from "react"

export default function Notification() {
  return (
    <p>商品の規格変更により、パッケージのデザインが異なる場合がございます。</p>
  )
}
